export { default } from "./QuizQuestionText";
